import { useState } from 'react'
import axios from 'axios'
import { useQuery } from "react-query"

const URL = '/api/tracker/public-statuses/'

const usePublicStatuses = () => {
  const [publicStatuses, setPublicStatuses] = useState([])
  const token = localStorage.getItem('token')

  const {isLoading} = useQuery(
    "public-statuses",
    async () => {
      const r = await axios.get(URL, {
        headers: {
          Authorization: `Token ${token}`
        }
      })
      return r.data
    },
    {
      staleTime: Infinity,
      refetchInterval: false,
      onSuccess: (data) => {
        setPublicStatuses(data)
      },
      onError: (err) => {
        console.log(err)
      }
    }
  )

  return [publicStatuses, isLoading]
}

export default usePublicStatuses